import React from "react";
import { useContent } from "../context/ContentContext";
import { useTranslation } from "../hooks/useTranslation";

const TranslationOverlay = () => {
  const { isTranslating } = useContent();
  const { t } = useTranslation();

  if (!isTranslating) return null;

  return (
    <div className="fixed inset-x-0 top-2 z-[200] flex justify-center">
      <div className="pointer-events-none bg-black/70 backdrop-blur-sm rounded-md px-3 py-2 flex items-center space-x-3 shadow-md">
        <div className="w-4 h-4 border-2 border-white/70 border-t-transparent rounded-full animate-spin" />
        <span className="text-white text-sm">{t("loading")}</span>
      </div>
    </div>
  );
};

export default TranslationOverlay;
